import axios, { AxiosResponse } from "axios";
import { APP_Config } from "./helpers/AppConfig";
import { getFromSession } from "./helpers/GenericHelpers";
import { ICreateProjectInput } from "./models/APIModels";
import { IProjectModel } from "./models/SharedModel";
import { configFormData, modifyFormData } from "./helpers/ServiceHelpers";
import { ILogsModel } from "./models/LogsModel";


class Service {
  base_url = APP_Config()?.REACT_APP_BASE_URL;
  
  constructor() {
    axios.interceptors.request.use(
      config => {
        const user_id = getFromSession('user_id')
          if(user_id) {
              config.headers['user-id'] = user_id;
          }
          return config;
      }
    );
  }

  // Todo: change any to specific type
  create_project = (payload: ICreateProjectInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/da_create_project`, formData, configFormData)
  }

  get_project_list = (): Promise<AxiosResponse<IProjectModel[]>> => {
    const formData = new FormData();
    const user_id = getFromSession('user_id')
    formData.append('user_id',user_id );
    return axios.post(`${this.base_url}/docai_get_list_of_projects`,formData)
  }

  get_byte_files = () => 
    axios.get(`${this.base_url}/get_byte_files`)
  
  get_frontend_logs = () => 
    axios.post(`${this.base_url}/get_frontend_logs`)

  save_frontend_logs = (data: ILogsModel[]) => 
    axios.post(`${this.base_url}/save_frontend_logs`, data)

  gpt_vision = (data: any) => 
    axios.post(`${this.base_url}/gpt_vision`, data)

  add_user_details = (data: any) =>{
    const formData = new FormData()
    formData.append('username', data.username);
    return axios.post(`${this.base_url}/add_user_details`, formData, configFormData)
  }

  get_logged_in_user = (data: any) =>{
    const formData = new FormData()
    formData.append('username', data.username);
    return axios.post(`${this.base_url}/get_logged_in_user`, formData, configFormData)
  }

  create_workspace = (data: any) =>{
    return axios.post(`${this.base_url}/create_workspace`, data)
  }

  get_list_of_users = () =>{
    const formData = new FormData()
    return axios.post(`${this.base_url}/get_list_of_users`, formData, configFormData)
  }

  get_workspace_details = (user_id:string) =>{
    const formData = new FormData();
    formData.append('workspace_owner',user_id)
    return axios.post(`${this.base_url}/get_workspace_details`,formData, configFormData)
  }

  workspace_project_mapping = (data:any) =>{
    const formData = new FormData();
    formData.append('workspace_id',data?.workspace_id)
    formData.append('project_id',data?.project_id)
    return axios.post(`${this.base_url}/workspace_project_mapping`,formData, configFormData)
  }

  workspace_users_mapping = (data:any) =>{
    // formData.append('workspace_id',data?.workspace_id)
    // formData.append('user_id',data?.user_id)
    return axios.post(`${this.base_url}/workspace_users_mapping`,data,)
  }

  add_project_configuration = (data:any) =>{
    return axios.post(`${this.base_url}/add_project_configuration`,data,)
  }

  get_project_configuration_details = (data:any) =>{
    return axios.post(`${this.base_url}/get_project_configuration_details`,data,)
  }

  testSocketService = () =>{
    return axios.get('http://127.0.0.1:5000/about')
  }

}

export default Service;
